const countFormat = new Intl.NumberFormat("en-GB");

export function formatCount(value: number): string {
  return countFormat.format(Math.round(value));
}

export function formatBytes(value: number): string {
  if (value >= 1e12) return `${(value / 1e12).toFixed(1)} TB`;
  if (value >= 1e9) return `${(value / 1e9).toFixed(1)} GB`;
  if (value >= 1e6) return `${String(Math.round(value / 1e6))} MB`;
  if (value <= 0) return "0 MB";
  return `${String(Math.max(1, Math.round(value / 1e3)))} kB`;
}

export function formatDuration(seconds: number): string {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  return `${String(h)}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

export function formatCost(amount: string): string {
  const n = Number(amount);
  return n === 0 ? "USD 0" : `USD ${n < 0.01 ? n.toFixed(3) : n.toFixed(2)}`;
}
